import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import * as PoziUtils from 'api/utils'
import LayerPanelAbout from 'drawer/tabs/layers/about/LayerPanelAbout'
import LayerPanelEdit from 'drawer/tabs/layers/annotations/LayerPanelEdit'
import LayerDownload from 'drawer/tabs/layers/download/LayerDownload'
import LayerFilter from 'drawer/tabs/layers/filter/LayerFilter'
import FilterSource from 'drawer/tabs/layers/filtersource/FilterSource'
// import LayerPanelLegend from 'drawer/tabs/layers/panels/LayerPanelLegend'
import LayerPanelOpacity from 'drawer/tabs/layers/panels/LayerPanelOpacity'
import LayerPanelTable from 'drawer/tabs/layers/panels/LayerPanelTable'
import LayerReport from 'drawer/tabs/layers/report/LayerReport'
import { getMap } from 'utils/MapUtils'

const styles = {
  root: {
    margin: 10,
    padding: 0,
    paddingLeft: 6,
    paddingRight: 6,
    paddingBottom: 14,
    minWidth: 250,
    transition: 'all 0.5s'
  }
}

class LayerMenu_ extends React.PureComponent {
  // Store reference to OL map
  map = getMap()

  render () {
    const { classes, onSelect, titleid } = this.props
    if (!titleid) {
      console.log('LayerMenu - called without titleid:', titleid)
    }

    const layerConf = PoziUtils.getLayerFromTitleID(titleid)
    if (!layerConf) {
      console.log(`LayerMenu - layer config not found for '${titleid}'. Not rendering menu.`)
      return null
    }

    console.debug('LayerMenu', titleid)

    // TODO: move this edit enabled logic to the LayerPanelEdit component
    const state = window.store.getState()
    const bLayerEditEnabled = get(state, 'layers[' + titleid + '].edit', false)
    const bEditEnabled = true

    const layerComponent = (
      <div className={classes.root}>
        {bEditEnabled && bLayerEditEnabled
          ? (
          <LayerPanelEdit map={this.map} titleid={titleid} />
            )
          : null}
        {/* <LayerPanelLegend titleid={titleid} /> */}
        <FilterSource titleid={titleid} />
        <LayerPanelOpacity titleid={titleid} />
        <LayerFilter titleid={titleid} />
        <LayerReport titleid={titleid} />
        <LayerPanelTable titleid={titleid} onSelect={onSelect} />
        <LayerDownload titleid={titleid} />
        <LayerPanelAbout titleid={titleid} />
      </div>
    )

    return layerComponent
  }
}

LayerMenu_.propTypes = {
  classes: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
  titleid: PropTypes.string.isRequired
}

const LayerMenu = (
  withStyles(styles)(LayerMenu_)
)

export default LayerMenu
